import "./ModalScheduling.scss";

import * as formik from "formik";
import * as yup from "yup";

import { Form, Modal } from "react-bootstrap";
import { useEffect, useMemo, useState } from "react";

import AppButton from "../../../../commons/buttons/AppButton";
import AppCurrencyInputV2 from "../../../../commons/inputs/AppCurrencyInputV2";
import AppInputV2 from "../../../../commons/inputs/AppInputV2";
import AppLinkButton from "../../../../commons/buttons/AppLinkButton";
import AppLoading from "../../../../commons/AppLoading";
import AppSelectV2 from "../../../../commons/inputs/AppSelectV2";
import CalendarInputV2 from "../../../../commons/inputs/CalendarInputV2";
import CommandAPI from "../../../commands/CommandAPI";
import CommandPaymentModal from "../../../commands/components/CommandPaymentModal";
import CompanyAPI from "../../../company/CompanyAPI";
import ConfirmModal from "../../../../commons/modal/ConfirmModal";
import CustomerAutocomplete from "../../../commands/components/CustomerAutocomplete";
import CustomerDetailsModalV2 from "../../../customer/components/details/CustomerDetailsModalV2";
import HallAppCenterContainer from "../../../../commons/containers/HallAppCenterContainer";
import HallAppToast from "../../../../commons/HallAppToast";
import ModalCommand from "../../../commands/components/Command";
import ProductsAPI from "../../../stock/ProductsAPI";
import SchedulingAPI from "../../SchedulingAPI";
import ServiceAPI from "../../../services/ServiceAPI";
import UserService from "../../../../auth/UserService";
import dayjs from "dayjs";
import { formatDateInEN } from "../../../../commons/util/HallAppUtil";
import { useMask } from "@react-input/mask";

const serviceAPI = new ServiceAPI();
const companyAPI = new CompanyAPI();
const schedulingAPI = new SchedulingAPI();
const userService = new UserService();
const commandAPI = new CommandAPI();
const productAPI = new ProductsAPI();

const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

function timeToMinutesOrNull(time) {
  if (!time || !timeRegex.test(time)) return null;
  const [h, m] = time.split(":").map(Number);
  return h * 60 + m;
}

function minutesToTime(mins) {
  if (mins == null || !Number.isFinite(mins)) return "";
  const v = ((mins % 1440) + 1440) % 1440;
  const h = String(Math.floor(v / 60)).padStart(2, "0");
  const m = String(v % 60).padStart(2, "0");
  return `${h}:${m}`;
}

function normalizeDurationToMinutes(duration) {
  const d = Number(duration);
  if (!Number.isFinite(d) || d <= 0) return 0;
  return Math.round(d);
}

function calcEndTime(startTime, duration) {
  const startMins = timeToMinutesOrNull(startTime);
  if (startMins == null) return "";
  const dur = normalizeDurationToMinutes(duration);
  if (!dur) return "";
  return minutesToTime(startMins + dur);
}

function formatCurrencyPreview(value) {
  const numberValue = Number(value);
  if (!Number.isFinite(numberValue)) return "R$ 0,00";
  return `R$ ${numberValue.toFixed(2).replace(".", ",")}`;
}

function buildTimeRangeLabel(startTime, endTime) {
  const hasStart = !!startTime;
  const hasEnd = !!endTime;

  if (hasStart && hasEnd) return `${startTime} - ${endTime}`;
  if (hasStart) return `${startTime}`;
  return "Horário não informado";
}

function ModalScheduling({
  closeShow,
  show,
  call,
  eventSelected,
  employees = [],
  currentEmployee,
  initialDate,
  initialStartTime,
}) {
  const [initialValues, setInitialValues] = useState({
    name: "",
    whatsapp: "",
    description: "",
    value: "",
    customerId: null,
    birthday: null,
    lastVisit: null,
  });

  const [isLoading, setLoading] = useState(false);
  const [isLoadingPage, setLoadingPage] = useState(true);
  const [services, setServices] = useState([]);
  const [products, setProducts] = useState([]);
  const [serviceDate, setServiceDate] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [serviceItems, setServiceItems] = useState([]);
  const [expandedServiceKey, setExpandedServiceKey] = useState(null);

  const [productItems, setProductItems] = useState([]);
  const [expandedProductKey, setExpandedProductKey] = useState(null);

  const [showModalCommand, setShowModalCommand] = useState(false);
  const [command, setCommand] = useState({});
  const [isLoadingCommand, setLoadingCommand] = useState(false);
  const [showModalPayment, setShowModalPayment] = useState(false);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [showForceModal, setShowForceModal] = useState(false);
  const [forcePayload, setForcePayload] = useState(null);
  const [pendingGenerateAfterForce, setPendingGenerateAfterForce] = useState(false);
  const [commandGeneretedId, setCommandGeneretedId] = useState(null);
  const [generatedCommandStatus, setGeneratedCommandStatus] = useState(null);
  const [showCustomerDetails, setShowCustomerDetails] = useState(false);

  const { Formik } = formik;

  const schema = yup.object().shape({
    name: yup.string().required("Nome é obrigatório"),
    whatsapp: yup.string().required("Telefone é obrigatório"),
  });

  const hoursStartMask = useMask({ mask: "__:__", replacement: { _: /\d/ } });
  const hoursEndMask = useMask({ mask: "__:__", replacement: { _: /\d/ } });

  function formatPhoneNumber(phone) {
    if (!phone || phone.length !== 11) return "";
    return `(${phone.slice(0, 2)}) ${phone.slice(2, 7)}-${phone.slice(7)}`;
  }

  function formatCurrency(value) {
    return Number(value || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  function resolveProductPrice(productOption) {
    if (!productOption) return 0;
    return Number(productOption?.pricing?.customerSalePrice || 0);
  }

  function getProductStock(productOption) {
    return Number(productOption?.inventory?.currentQuantity || 0);
  }

  function buildEmptyProductItem() {
    return {
      key: Date.now() + Math.random(),
      product: null,
      employee: currentEmployee || null,
      quantity: 1,
      unitPrice: 0,
      totalPrice: 0,
      observation: "",
    };
  }

  function calcProductTotal(quantity, unitPrice) {
    const q = Number(quantity || 0);
    const p = Number(unitPrice || 0);
    return q * p;
  }

  async function openPaymentModalByCommandId(commandId) {
    if (!commandId) return;

    try {
      setLoadingCommand(true);
      const resp = await commandAPI.findById(commandId);
      setCommand(resp.data);
      setShowModalPayment(true);
    } catch (e) {
      HallAppToast.genericError();
    } finally {
      setLoadingCommand(false);
    }
  }

  const updateServiceItem = (key, field, value) => {
    setServiceItems((prev) =>
      prev.map((item) => (item.key === key ? { ...item, [field]: value } : item))
    );
  };

  const updateProductItem = (key, field, value) => {
    setProductItems((prev) =>
      prev.map((item) => {
        if (item.key !== key) return item;

        const nextItem = { ...item, [field]: value };

        if (field === "product") {
          const nextUnitPrice = resolveProductPrice(value);
          nextItem.unitPrice = nextUnitPrice;
          nextItem.totalPrice = calcProductTotal(nextItem.quantity, nextUnitPrice);
        }

        if (field === "quantity") {
          nextItem.totalPrice = calcProductTotal(value, nextItem.unitPrice);
        }

        if (field === "unitPrice") {
          nextItem.totalPrice = calcProductTotal(nextItem.quantity, value);
        }

        return nextItem;
      })
    );
  };

  function buildEmptyServiceItem(startTime = "") {
    return {
      key: Date.now() + Math.random(),
      employee: currentEmployee || null,
      service: null,
      startTime,
      endTime: "",
      value: "",
      duration: 0,
    };
  }

  const addServiceItem = () => {
    const ordered = [...serviceItems].sort((a, b) => {
      const am = timeToMinutesOrNull(a.startTime) ?? Number.MAX_SAFE_INTEGER;
      const bm = timeToMinutesOrNull(b.startTime) ?? Number.MAX_SAFE_INTEGER;
      return am - bm;
    });

    const last = ordered[ordered.length - 1];
    let nextStart = "";

    if (last) {
      nextStart =
        (last.endTime && timeRegex.test(last.endTime) && last.endTime) ||
        calcEndTime(last.startTime, last.duration ?? last.service?.duration) ||
        "";
    }

    const newItem = buildEmptyServiceItem(nextStart);
    setServiceItems((prev) => [...prev, newItem]);
    setExpandedServiceKey(newItem.key);
  };

  const addProductItem = () => {
    const newItem = buildEmptyProductItem();
    setProductItems((prev) => [...prev, newItem]);
    setExpandedProductKey(newItem.key);
  };

  const removeServiceItem = (key) => {
    setServiceItems((prev) => {
      const nextItems = prev.filter((item) => item.key !== key);
      if (expandedServiceKey === key) {
        setExpandedServiceKey(nextItems[0]?.key ?? null);
      }
      return nextItems;
    });
  };

  const removeProductItem = (key) => {
    setProductItems((prev) => {
      const nextItems = prev.filter((item) => item.key !== key);
      if (expandedProductKey === key) {
        setExpandedProductKey(nextItems[0]?.key ?? null);
      }
      return nextItems;
    });
  };

  function toggleServiceCard(key) {
    setExpandedServiceKey((prev) => (prev === key ? null : key));
  }

  function toggleProductCard(key) {
    setExpandedProductKey((prev) => (prev === key ? null : key));
  }

  function validateServiceItems() {
    if (!serviceItems.length) {
      HallAppToast.error("Adicione pelo menos um serviço.");
      return false;
    }

    for (const item of serviceItems) {
      if (!item.employee) {
        HallAppToast.error("Selecione o profissional em todos os serviços.");
        return false;
      }
      if (!item.service) {
        HallAppToast.error("Selecione o tipo de serviço em todos os serviços.");
        return false;
      }
      if (!item.startTime || !timeRegex.test(item.startTime)) {
        HallAppToast.error("Informe um horário de início válido (HH:mm).");
        return false;
      }
      if (!item.endTime || !timeRegex.test(item.endTime)) {
        HallAppToast.error("Informe um horário final válido (HH:mm).");
        return false;
      }
    }

    return true;
  }

  function validateProductItems() {
    for (const item of productItems) {
      if (!item.product) {
        HallAppToast.error("Selecione o produto em todos os itens de produto.");
        return false;
      }

      if (!item.employee) {
        HallAppToast.error("Selecione o profissional em todos os produtos.");
        return false;
      }

      if (!Number(item.quantity || 0) || Number(item.quantity) <= 0) {
        HallAppToast.error("Informe uma quantidade válida em todos os produtos.");
        return false;
      }

      const stock = getProductStock(item.product);

      if (stock <= 0) {
        HallAppToast.error(
          `O produto "${item.product?.label || item.product?.name || ""}" está sem estoque.`
        );
        return false;
      }

      if (Number(item.quantity) > stock) {
        HallAppToast.error(
          `A quantidade do produto "${item.product?.label || item.product?.name || ""}" é maior que o estoque disponível.`
        );
        return false;
      }
    }

    return true;
  }

  const findAllServices = async () => {
    const response = await serviceAPI.findAllByCompanyId(companyAPI.getCompanyManagment().id);

    const options = (response.data || [])
      .sort((a, b) => a.categoryName.localeCompare(b.categoryName))
      .map((d) => ({
        value: d.id,
        label: d.name,
        price: d?.value || 0,
        duration: d?.duration || 0,
      }));

    setServices(options);
    return options;
  };

  const findAllProducts = async () => {
    const response = await productAPI.findAll();

    const options = (response.data || [])
      .filter((item) => item?.active)
      .map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));

    setProducts(options);
    return options;
  };

  const fetchEventData = async () => {
    if (!eventSelected) return null;

    if (eventSelected?.groupId) {
      const response = await schedulingAPI.findByGroupId(eventSelected.groupId);
      return response.data;
    }

    const response = await schedulingAPI.findById(eventSelected.id);
    return response.data;
  };

  const syncCurrentEventState = (eventData) => {
    if (!eventData) return;

    setCurrentEvent(eventData);

    const nextCommandId = eventData?.commandId || eventData?.command?.id || null;
    const nextCommandStatus = eventData?.commandStatus || eventData?.command?.status || null;

    setCommandGeneretedId(nextCommandId);
    setGeneratedCommandStatus(nextCommandStatus);
  };

  const reloadCurrentEvent = async () => {
    if (!eventSelected) return null;

    try {
      const data = await fetchEventData();
      syncCurrentEventState(data);
      return data;
    } catch (_) {
      return null;
    }
  };

  const findByEventId = async () => {
    try {
      setLoadingPage(true);

      await Promise.all([findAllServices(), findAllProducts()]);

      if (!eventSelected) {
        setCurrentEvent(null);
        setLoadingPage(false);
        return;
      }

      const data = await fetchEventData();
      syncCurrentEventState(data);
      setLoadingPage(false);
    } catch (e) {
      setLoadingPage(false);
    }
  };

  function populateFormEdit(eventData) {
    if (!eventData) return;

    const eventDate = eventData.date || eventData.schedulingDate;
    setServiceDate(eventDate);
    setStartDate(dayjs(eventDate).toDate());

    setInitialValues((prev) => ({
      ...prev,
      name: eventData?.name || "",
      whatsapp: formatPhoneNumber(eventData?.phone || ""),
      description: eventData?.description || "",
      value: eventData?.value ?? "",
      customerId: eventData?.customerId ?? null,
      birthday: eventData?.birthday ?? null,
      lastVisit: eventData?.lastVisit ?? null,
    }));

    const items = (eventData?.services || []).map((svc, idx) => {
      const employeeOption = employees.find((e) => e.value === svc.employeeId) || null;
      const serviceOption = services.find((o) => o.value === svc.serviceId) || null;
      const start = svc.startTime || svc.time || "";
      const dur = svc.duration || serviceOption?.duration || 0;
      const end = svc.endTime || calcEndTime(start, dur);

      return {
        key: `${eventData.groupId || "grp"}-${svc.employeeId}-${svc.serviceId}-${start || idx}`,
        employee: employeeOption,
        service: serviceOption,
        startTime: start,
        endTime: end,
        value: svc.value ?? serviceOption?.price ?? "",
        duration: dur,
      };
    });

    const productRows = (eventData?.products || []).map((prd, idx) => {
      const productOption =
        products.find((p) => p.value === prd.productId || p.id === prd.productId) || null;

      const employeeOption =
        employees.find((e) => e.value === prd.employeeId || e.id === prd.employeeId) || null;

      const quantity = Number(prd.quantity || 1);
      const unitPrice = Number(prd.unitPrice || resolveProductPrice(productOption) || 0);

      return {
        key: `${eventData.groupId || "grp"}-product-${prd.productId}-${idx}`,
        product: productOption,
        employee: employeeOption,
        quantity,
        unitPrice,
        totalPrice: calcProductTotal(quantity, unitPrice),
        observation: prd.observation || "",
      };
    });

    setServiceItems(items.length ? items : [buildEmptyServiceItem(initialStartTime || "")]);
    setExpandedServiceKey(items[0]?.key ?? null);

    setProductItems(productRows);
    setExpandedProductKey(productRows[0]?.key ?? null);
  }

  useEffect(() => {
    if (!show) return;
    setCommandGeneretedId(null);
    setGeneratedCommandStatus(null);
    findByEventId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, eventSelected?.id, eventSelected?.groupId]);

  useEffect(() => {
    if (!show) return;

    if (!eventSelected) {
      const baseDate = initialDate ? new Date(initialDate) : new Date();
      const newItem = buildEmptyServiceItem(initialStartTime || "");

      setStartDate(baseDate);
      setServiceDate(formatDateInEN(baseDate));
      setServiceItems([newItem]);
      setExpandedServiceKey(newItem.key);

      setProductItems([]);
      setExpandedProductKey(null);
      return;
    }

    if (currentEvent && (currentEvent.services?.length ?? 0) >= 0 && services.length > 0) {
      populateFormEdit(currentEvent);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    show,
    eventSelected?.id,
    eventSelected?.groupId,
    currentEvent,
    services,
    products,
    initialDate,
    initialStartTime,
  ]);

  function handleChangeDate(date) {
    setServiceDate(date);
  }

  const canceledEvent = async () => {
    if (!eventSelected) return;

    setLoading(true);

    try {
      await schedulingAPI.canceledScheduling(eventSelected.id, userService.getUserData().id);
      HallAppToast.success();

      if (call) {
        call();
        closeShow();
      }
    } catch (_) {
      HallAppToast.genericError();
    } finally {
      setLoading(false);
    }
  };

  const extractErrorCode = (err) => {
    const data = err?.response?.data;
    if (Array.isArray(data) && data.length > 0) return data?.[0]?.code;
    if (data && typeof data === "object") return data?.code;
    return undefined;
  };

  const buildPayload = (values, force = false) => {
    const servicesPayload = serviceItems.map((item) => ({
      employeeId: item.employee?.value,
      employeeName: item.employee?.label,
      serviceId: item.service?.value,
      serviceName: item.service?.label,
      time: item.startTime,
      endTime: item.endTime,
      value: item.value,
      duration: item.duration ?? item.service?.duration ?? 0,
    }));

    const productsPayload = productItems.map((item) => ({
      productId: item.product?.value || item.product?.id,
      productName: item.product?.label || item.product?.name,
      employeeId: item.employee?.value || item.employee?.id,
      employeeName: item.employee?.label || item.employee?.name,
      saleType: "CLIENT",
      quantity: Number(item.quantity),
      unitPrice: Number(item.unitPrice || 0),
      totalPrice: Number(item.totalPrice || 0),
      observation: item.observation || null,
    }));

    return {
      date: serviceDate || formatDateInEN(new Date()),
      companyId: companyAPI.getCompanyManagment().id,
      name: values.name,
      phone: values.whatsapp,
      services: servicesPayload,
      products: productsPayload,
      eventId: eventSelected?.id ?? null,
      description: values.description,
      force,
    };
  };

  async function generateExistingDraftCommand(values, schedulingId) {
    const payload = buildPayload(values, false);
    const response = await schedulingAPI.generateCommand(schedulingId, payload);

    setCommandGeneretedId(response.data?.id ?? null);
    setGeneratedCommandStatus(response.data?.status ?? null);

    const updatedEvent = await reloadCurrentEvent();

    HallAppToast.successWithMessage("Comanda gerada com sucesso.");

    if (call) await call();

    return updatedEvent;
  }

  async function saveScheduling(values, { resetForm = () => {}, force = false, silent = false } = {}) {
    if (!validateServiceItems()) return { success: false, blocked: false, data: null };
    if (!validateProductItems()) return { success: false, blocked: false, data: null };

    const payload = buildPayload(values, force);

    try {
      if (eventSelected) {
        await schedulingAPI.updateByEmployee(eventSelected.id, payload);
        const updatedEvent = await reloadCurrentEvent();

        if (!silent) {
          if (updatedEvent) {
            HallAppToast.successWithMessage("Agendamento salvo com sucesso.");
          } else {
            HallAppToast.success();
          }
        }

        if (call) {
          await call();
        }

        return { success: true, blocked: false, data: updatedEvent };
      }

      const createResponse = await schedulingAPI.createByEmployee(payload);

      if (!silent) {
        HallAppToast.success();
      }

      resetForm();

      const baseDate = initialDate ? new Date(initialDate) : new Date();
      const newItem = buildEmptyServiceItem(initialStartTime || "");

      setStartDate(baseDate);
      setServiceDate(formatDateInEN(baseDate));
      setServiceItems([newItem]);
      setExpandedServiceKey(newItem.key);

      setProductItems([]);
      setExpandedProductKey(null);

      if (call) {
        await call();
      }

      return { success: true, blocked: false, data: createResponse?.data ?? null };
    } catch (err) {
      const code = extractErrorCode(err);

      if (code === "CLOSED_DIARY" && !force) {
        setForcePayload(buildPayload(values, true));
        setShowForceModal(true);
        return { success: false, blocked: true, data: null };
      }

      throw err;
    }
  }

  const create = async (values, { resetForm }) => {
    setLoading(true);

    try {
      await saveScheduling(values, { resetForm });
    } catch (_) {
      HallAppToast.genericError();
    } finally {
      setLoading(false);
    }
  };

  async function handleGenerateCommand(values, resetForm = () => {}) {
    if (!eventSelected) return;

    if (!validateServiceItems()) return;
    if (!validateProductItems()) return;

    setLoading(true);

    try {
      const hasDraftCommand = !!effectiveCommandId && effectiveCommandStatus === "DRAFT";

      if (hasDraftCommand) {
        await generateExistingDraftCommand(values, eventSelected.id);
        return;
      }

      const saveResult = await saveScheduling(values, {
        resetForm,
        silent: true,
      });

      if (saveResult?.blocked) {
        setPendingGenerateAfterForce(true);
        return;
      }

      if (!saveResult?.success) {
        return;
      }

      const updatedEvent = await reloadCurrentEvent();

      const commandId = updatedEvent?.commandId || updatedEvent?.command?.id || null;
      const commandStatus = updatedEvent?.commandStatus || updatedEvent?.command?.status || null;
      const schedulingId = updatedEvent?.id || eventSelected?.id;

      if (commandId && commandStatus === "DRAFT") {
        await generateExistingDraftCommand(values, schedulingId);
        return;
      }

      HallAppToast.error("Agendamento salvo, mas não foi possível localizar a comanda em rascunho.");
    } catch (_) {
      HallAppToast.genericError();
    } finally {
      setLoading(false);
    }
  }

  const confirmForceCreate = async () => {
    if (!forcePayload) return;

    setLoading(true);

    try {
      if (eventSelected) {
        await schedulingAPI.updateByEmployee(eventSelected.id, forcePayload);
        const updatedEvent = await reloadCurrentEvent();

        if (pendingGenerateAfterForce) {
          const commandId = updatedEvent?.commandId || updatedEvent?.command?.id || null;
          const commandStatus = updatedEvent?.commandStatus || updatedEvent?.command?.status || null;
          const schedulingId = updatedEvent?.id || eventSelected?.id;

          if (commandId && commandStatus === "DRAFT") {
            const response = await schedulingAPI.generateCommand(schedulingId, forcePayload);

            setCommandGeneretedId(response.data?.id ?? null);
            setGeneratedCommandStatus(response.data?.status ?? null);
            await reloadCurrentEvent();

            HallAppToast.successWithMessage("Agendamento salvo e comanda gerada com sucesso.");
          } else {
            HallAppToast.successWithMessage(
              "Agendamento salvo, mas não foi possível localizar a comanda em rascunho."
            );
          }
        } else {
          HallAppToast.success();
        }
      } else {
        await schedulingAPI.createByEmployee(forcePayload);
        HallAppToast.success();
      }

      setShowForceModal(false);
      setForcePayload(null);
      setPendingGenerateAfterForce(false);

      if (call) {
        call();
      }
    } catch (_) {
      HallAppToast.genericError();
    } finally {
      setLoading(false);
    }
  };

  const effectiveCommandId =
    currentEvent?.commandId ||
    currentEvent?.command?.id ||
    eventSelected?.commandId ||
    commandGeneretedId ||
    null;

  const effectiveCommandStatus =
    currentEvent?.commandStatus ||
    currentEvent?.command?.status ||
    generatedCommandStatus ||
    eventSelected?.commandStatus ||
    null;

  async function openPaymentModalByEvent() {
    return openPaymentModalByCommandId(effectiveCommandId);
  }

  function timeToMinutes(time) {
    const v = timeToMinutesOrNull(time);
    return v == null ? Number.MAX_SAFE_INTEGER : v;
  }

  function onlyDigits(str) {
    return (str || "").replace(/\D/g, "");
  }

  function buildWhatsAppUrl(phone) {
    const digits = onlyDigits(phone);
    if (digits.length < 10) return null;
    return `https://wa.me/55${digits}`;
  }

  function openWhatsApp(phone) {
    const url = buildWhatsAppUrl(phone);

    if (!url) {
      HallAppToast.error("Informe um WhatsApp válido.");
      return;
    }

    window.open(url, "_blank", "noopener,noreferrer");
  }

  const sortedServiceItems = useMemo(() => {
    return [...serviceItems].sort((a, b) => timeToMinutes(a.startTime) - timeToMinutes(b.startTime));
  }, [serviceItems]);

  const totalValue = useMemo(() => {
    return serviceItems.reduce((acc, item) => {
      const v = Number(item.value);
      return acc + (isNaN(v) ? 0 : v);
    }, 0);
  }, [serviceItems]);

  const totalProductsValue = useMemo(() => {
    return productItems.reduce((acc, item) => {
      return acc + Number(item.totalPrice || 0);
    }, 0);
  }, [productItems]);

  const totalCommandValue = useMemo(() => {
    return Number(totalValue || 0) + Number(totalProductsValue || 0);
  }, [totalValue, totalProductsValue]);

  const showGenerateCommandButton = useMemo(() => {
    return !!eventSelected && (!effectiveCommandId || effectiveCommandStatus === "DRAFT");
  }, [eventSelected, effectiveCommandId, effectiveCommandStatus]);

  const showConfirmPaymentButton = useMemo(() => {
    return !!eventSelected && !!effectiveCommandId && !!effectiveCommandStatus && effectiveCommandStatus !== "DRAFT";
  }, [eventSelected, effectiveCommandId, effectiveCommandStatus]);

  function getServicePriceById(serviceId) {
    if (!serviceId) return "";
    const opt = services.find((s) => s.value === serviceId);
    return opt?.price ?? "";
  }

  function applyServiceDefaultPrice(itemKey, serviceId) {
    const price = getServicePriceById(serviceId);
    updateServiceItem(itemKey, "value", price);
  }

  return (
    <div className="modal-add-scheduling">
      <Modal
        show={show}
        fullscreen
        centered
        onHide={() => closeShow()}
        dialogClassName="modal-scheduling-dialog"
        contentClassName="modal-scheduling-content"
      >
        <Modal.Header closeButton className="modal-scheduling-header">
          <div className="ms-header">
            <Modal.Title className="modal-scheduling-title">
              {eventSelected ? "Editar agendamento" : "Novo agendamento"}
            </Modal.Title>
            <div className="ms-header-subtitle">
              {eventSelected
                ? "Revise os dados e salve as alterações."
                : "Preencha os campos abaixo para criar o agendamento."}
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="modal-scheduling-body">
          {isLoadingPage || isLoadingCommand ? (
            <AppLoading />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={create}
              initialValues={initialValues}
              enableReinitialize
            >
              {({ handleSubmit, handleChange, values, touched, errors, setFieldValue, resetForm }) => {
                const hasSelectedCustomer =
                  !!values?.name &&
                  (values?.whatsapp || "").replace(/\D/g, "").length >= 10;

                return (
                  <>
                    <Form
                      noValidate
                      onSubmit={handleSubmit}
                      className="container-lg modal-scheduling-form"
                    >
                      {buildWhatsAppUrl(values.whatsapp) && (
                        <div className="ms-whatsapp-bar">
                          <div className="ms-whatsapp-icon-wrap">💬</div>
                          <div className="ms-whatsapp-content">
                            <div className="ms-whatsapp-label">Contato rápido pelo WhatsApp</div>
                            <button
                              type="button"
                              className="ms-whatsapp-btn"
                              onClick={() => openWhatsApp(values.whatsapp)}
                            >
                              Abrir conversa no WhatsApp
                            </button>
                          </div>
                        </div>
                      )}

                      <div className="ms-section">
                        <div className="ms-section-header">
                          <div className="ms-section-badge">1</div>
                          <div>
                            <div className="ms-section-title">Data e cliente</div>
                            <div className="ms-section-subtitle">
                              Escolha a data e informe os dados do cliente.
                            </div>
                          </div>
                        </div>

                        <div className="ms-fields-stack">
                          <div className="ms-field-block">
                            <CalendarInputV2
                              selectionMode="single"
                              setDates={setStartDate}
                              changeDates={handleChangeDate}
                              values={startDate}
                              name="date"
                              label="Data do atendimento"
                              className="w-100"
                            />
                          </div>

                          <div className="ms-field-block">
                            <CustomerAutocomplete
                              isRequired
                              touched={touched}
                              name="whatsapp"
                              errors={errors}
                              value={values.whatsapp}
                              onChange={(val) => {
                                if (typeof val === "string") {
                                  setFieldValue("whatsapp", val);
                                } else if (val) {
                                  setFieldValue("customerId", val.id ?? null);
                                  setFieldValue("birthday", val.birthday ?? null);
                                  setFieldValue("lastVisit", val.lastVisit ?? null);
                                  setFieldValue("whatsapp", val.whatsapp || "");
                                  setFieldValue("name", val.name || "");
                                }
                              }}
                            />
                            <div className="ms-hint">
                              Digite o número ou nome para buscar um cliente já cadastrado.
                            </div>

                            {hasSelectedCustomer && (
                              <button
                                type="button"
                                className="ms-customer-details-btn"
                                onClick={() => setShowCustomerDetails(true)}
                              >
                                <span className="ms-customer-details-icon">👤</span>
                                Ver detalhes do cliente
                              </button>
                            )}
                          </div>

                          <div className="ms-field-block ms-field-full">
                            <AppInputV2
                              isRequired
                              errors={errors}
                              touched={touched}
                              name="name"
                              onChange={handleChange}
                              value={values.name}
                              type="text"
                              label="Nome do cliente"
                              className="mb-0"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="ms-section">
                        <div className="ms-section-header ms-section-header--row">
                          <div className="ms-section-header-left">
                            <div className="ms-section-badge">2</div>
                            <div>
                              <div className="ms-section-title">Serviços</div>
                              <div className="ms-section-subtitle">
                                Adicione um ou mais itens de atendimento.
                              </div>
                            </div>
                          </div>
                          <button
                            type="button"
                            className="ms-add-service-btn"
                            onClick={addServiceItem}
                            disabled={isLoading}
                          >
                            + Adicionar
                          </button>
                        </div>

                        <div className="ms-service-list">
                          {sortedServiceItems.map((item, index) => {
                            const isExpanded = expandedServiceKey === item.key;
                            const summaryService = item.service?.label || "Serviço não selecionado";
                            const summaryEmployee = item.employee?.label || "Profissional não selecionado";
                            const summaryValue = formatCurrencyPreview(item.value);
                            const summaryTime = buildTimeRangeLabel(item.startTime, item.endTime);

                            return (
                              <div
                                key={item.key}
                                className={`ms-service-card ${isExpanded ? "ms-service-card--expanded" : ""}`}
                              >
                                <button
                                  type="button"
                                  className="ms-service-summary"
                                  onClick={() => toggleServiceCard(item.key)}
                                  disabled={isLoading}
                                >
                                  <div className="ms-service-summary-top">
                                    <div className="ms-service-card-title">
                                      Atendimento {index + 1}
                                    </div>
                                    <div className="ms-service-summary-toggle">
                                      {isExpanded ? "Ocultar" : "Editar"}
                                    </div>
                                  </div>

                                  <div className="ms-service-summary-grid">
                                    <div className="ms-service-summary-item">
                                      <span className="ms-service-summary-label">Serviço</span>
                                      <span className="ms-service-summary-value">{summaryService}</span>
                                    </div>

                                    <div className="ms-service-summary-item">
                                      <span className="ms-service-summary-label">Profissional</span>
                                      <span className="ms-service-summary-value">{summaryEmployee}</span>
                                    </div>

                                    <div className="ms-service-summary-item">
                                      <span className="ms-service-summary-label">Valor</span>
                                      <span className="ms-service-summary-value">{summaryValue}</span>
                                    </div>

                                    <div className="ms-service-summary-item">
                                      <span className="ms-service-summary-label">Horário</span>
                                      <span className="ms-service-summary-value">{summaryTime}</span>
                                    </div>
                                  </div>

                                  <div className="ms-service-summary-hint">
                                    Clique no card para editar
                                  </div>
                                </button>

                                {isExpanded && (
                                  <div className="ms-service-card-body">
                                    <div className="ms-service-card-header">
                                      <div className="ms-service-card-title">
                                        Editando atendimento {index + 1}
                                      </div>
                                      {serviceItems.length > 1 && (
                                        <button
                                          type="button"
                                          className="ms-remove-btn"
                                          onClick={() => removeServiceItem(item.key)}
                                          disabled={isLoading}
                                        >
                                          Remover
                                        </button>
                                      )}
                                    </div>

                                    <div className="ms-fields-stack">
                                      <div className="ms-field-block">
                                        <AppSelectV2
                                          name={`employee-${item.key}`}
                                          label="Profissional"
                                          placeholder="Selecione o profissional"
                                          options={employees}
                                          value={item.employee}
                                          onChange={(opt) => updateServiceItem(item.key, "employee", opt)}
                                        />
                                      </div>

                                      <div className="ms-field-block">
                                        <AppSelectV2
                                          name={`service-${item.key}`}
                                          label="Serviço"
                                          placeholder="Selecione o serviço"
                                          options={services}
                                          value={item.service}
                                          onChange={(opt) => {
                                            updateServiceItem(item.key, "service", opt);
                                            updateServiceItem(item.key, "value", opt?.price ?? "");
                                            updateServiceItem(item.key, "duration", opt?.duration ?? 0);

                                            const newEnd = calcEndTime(item.startTime, opt?.duration ?? 0);

                                            if (newEnd) {
                                              updateServiceItem(item.key, "endTime", newEnd);
                                            }
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="ms-time-row">
                                      <div className="ms-field-block">
                                        <AppInputV2
                                          errors={{}}
                                          touched={{}}
                                          name={`startTime-${item.key}`}
                                          onChange={(e) => {
                                            const v = e.target.value;
                                            updateServiceItem(item.key, "startTime", v);

                                            const dur = item.duration ?? item.service?.duration ?? 0;
                                            const newEnd = calcEndTime(v, dur);

                                            if (newEnd) {
                                              updateServiceItem(item.key, "endTime", newEnd);
                                            }
                                          }}
                                          value={item.startTime}
                                          ref={hoursStartMask}
                                          type="text"
                                          label="Início"
                                        />
                                        <div className="ms-hint">Ex: 09:30</div>
                                      </div>

                                      <div className="ms-time-arrow">→</div>

                                      <div className="ms-field-block">
                                        <AppInputV2
                                          errors={{}}
                                          touched={{}}
                                          name={`endTime-${item.key}`}
                                          onChange={(e) => updateServiceItem(item.key, "endTime", e.target.value)}
                                          value={item.endTime}
                                          ref={hoursEndMask}
                                          type="text"
                                          label="Fim"
                                        />
                                        <div className="ms-hint">Ex: 10:15</div>
                                      </div>
                                    </div>

                                    <div className="ms-field-block ms-value-block">
                                      <AppCurrencyInputV2
                                        errors={{}}
                                        touched={{}}
                                        label="Valor do serviço"
                                        value={item.value}
                                        onChange={(_, value) => updateServiceItem(item.key, "value", value)}
                                      />
                                      <button
                                        type="button"
                                        className="ms-apply-price-btn"
                                        onClick={() => applyServiceDefaultPrice(item.key, item.service?.value)}
                                        disabled={isLoading}
                                      >
                                        Usar valor padrão do serviço
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>

                        {totalValue > 0 && (
                          <div className="ms-total-card">
                            <div className="ms-total-label">Valor total de serviços</div>
                            <div className="ms-total-value">
                              R$ {totalValue.toFixed(2).replace(".", ",")}
                            </div>
                          </div>
                        )}

                        <button
                          type="button"
                          className="ms-add-service-secondary"
                          onClick={addServiceItem}
                          disabled={isLoading}
                        >
                          + Adicionar outro serviço
                        </button>
                      </div>

                      <div className="ms-section">
                        <div className="ms-section-header ms-section-header--row">
                          <div className="ms-section-header-left">
                            <div className="ms-section-badge">3</div>
                            <div>
                              <div className="ms-section-title">Produtos</div>
                              <div className="ms-section-subtitle">
                                Adicione produtos vendidos nesta comanda.
                              </div>
                            </div>
                          </div>
                          <button
                            type="button"
                            className="ms-add-service-btn"
                            onClick={addProductItem}
                            disabled={isLoading}
                          >
                            + Adicionar
                          </button>
                        </div>

                        {productItems.length === 0 ? (
                          <div className="ms-empty-products">Nenhum produto adicionado.</div>
                        ) : (
                          <div className="ms-service-list">
                            {productItems.map((item, index) => {
                              const isExpanded = expandedProductKey === item.key;
                              const summaryProduct =
                                item.product?.label || item.product?.name || "Produto não selecionado";
                              const summaryEmployee =
                                item.employee?.label || item.employee?.name || "Profissional não selecionado";
                              const stock = getProductStock(item.product);

                              return (
                                <div
                                  key={item.key}
                                  className={`ms-service-card ${isExpanded ? "ms-service-card--expanded" : ""}`}
                                >
                                  <button
                                    type="button"
                                    className="ms-service-summary"
                                    onClick={() => toggleProductCard(item.key)}
                                    disabled={isLoading}
                                  >
                                    <div className="ms-service-summary-top">
                                      <div className="ms-service-card-title">Produto {index + 1}</div>
                                      <div className="ms-service-summary-toggle">
                                        {isExpanded ? "Ocultar" : "Editar"}
                                      </div>
                                    </div>

                                    <div className="ms-service-summary-grid">
                                      <div className="ms-service-summary-item">
                                        <span className="ms-service-summary-label">Produto</span>
                                        <span className="ms-service-summary-value">{summaryProduct}</span>
                                      </div>

                                      <div className="ms-service-summary-item">
                                        <span className="ms-service-summary-label">Profissional</span>
                                        <span className="ms-service-summary-value">{summaryEmployee}</span>
                                      </div>

                                      <div className="ms-service-summary-item">
                                        <span className="ms-service-summary-label">Tipo</span>
                                        <span className="ms-service-summary-value">Venda para cliente</span>
                                      </div>

                                      <div className="ms-service-summary-item">
                                        <span className="ms-service-summary-label">Total</span>
                                        <span className="ms-service-summary-value">
                                          {formatCurrency(item.totalPrice)}
                                        </span>
                                      </div>
                                    </div>

                                    <div className="ms-service-summary-hint">
                                      Clique no card para editar
                                    </div>
                                  </button>

                                  {isExpanded && (
                                    <div className="ms-service-card-body">
                                      <div className="ms-service-card-header">
                                        <div className="ms-service-card-title">
                                          Editando produto {index + 1}
                                        </div>
                                        <button
                                          type="button"
                                          className="ms-remove-btn"
                                          onClick={() => removeProductItem(item.key)}
                                          disabled={isLoading}
                                        >
                                          Remover
                                        </button>
                                      </div>

                                      <div className="ms-fields-stack">
                                        <div className="ms-field-block">
                                          <AppSelectV2
                                            name={`product-${item.key}`}
                                            label="Produto"
                                            placeholder="Selecione o produto"
                                            options={products}
                                            value={item.product}
                                            onChange={(opt) => updateProductItem(item.key, "product", opt)}
                                          />
                                        </div>

                                        <div className="ms-field-block">
                                          <AppSelectV2
                                            name={`product-employee-${item.key}`}
                                            label="Profissional (quem vendeu)"
                                            placeholder="Selecione o profissional"
                                            options={employees}
                                            value={item.employee}
                                            onChange={(opt) => updateProductItem(item.key, "employee", opt)}
                                          />
                                        </div>
                                      </div>

                                      <div className="ms-fields-stack">
                                        <div className="ms-field-block">
                                          <AppInputV2
                                            errors={{}}
                                            touched={{}}
                                            name={`product-quantity-${item.key}`}
                                            onChange={(e) =>
                                              updateProductItem(item.key, "quantity", e.target.value)
                                            }
                                            value={item.quantity}
                                            type="number"
                                            label="Quantidade"
                                          />
                                        </div>

                                        <div className="ms-field-block">
                                          <AppCurrencyInputV2
                                            errors={{}}
                                            touched={{}}
                                            label="Preço unitário"
                                            value={item.unitPrice}
                                            disabled
                                          />
                                        </div>
                                      </div>

                                      <div className="ms-fields-stack">
                                        <div className="ms-field-block">
                                          <AppCurrencyInputV2
                                            errors={{}}
                                            touched={{}}
                                            label="Valor total"
                                            value={item.totalPrice}
                                            disabled
                                          />
                                        </div>

                                        <div className="ms-field-block ms-field-full">
                                          <AppInputV2
                                            errors={{}}
                                            touched={{}}
                                            name={`product-observation-${item.key}`}
                                            onChange={(e) =>
                                              updateProductItem(item.key, "observation", e.target.value)
                                            }
                                            value={item.observation}
                                            type="text"
                                            label="Observação"
                                          />
                                        </div>
                                      </div>

                                      {item.product && (
                                        <div
                                          className="ms-hint"
                                          style={{
                                            color: stock > 0 ? "#374151" : "#dc2626",
                                            fontWeight: 600,
                                          }}
                                        >
                                          Estoque disponível: {stock}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}

                        {totalProductsValue > 0 && (
                          <div className="ms-total-card">
                            <div className="ms-total-label">Valor total de produtos</div>
                            <div className="ms-total-value">
                              R$ {totalProductsValue.toFixed(2).replace(".", ",")}
                            </div>
                          </div>
                        )}

                        <button
                          type="button"
                          className="ms-add-service-secondary"
                          onClick={addProductItem}
                          disabled={isLoading}
                        >
                          + Adicionar outro produto
                        </button>
                      </div>

                      {eventSelected && (
                        <div className="ms-section">
                          <div className="ms-section-header">
                            <div className="ms-section-badge">4</div>
                            <div>
                              <div className="ms-section-title">Observações</div>
                              <div className="ms-section-subtitle">
                                Alguma informação extra? (opcional)
                              </div>
                            </div>
                          </div>

                          <div className="ms-fields-stack">
                            <div className="ms-field-block ms-field-full">
                              <AppInputV2
                                errors={errors}
                                touched={touched}
                                name="description"
                                onChange={handleChange}
                                value={values.description}
                                type="text"
                                label="Descrição"
                                className="mb-0"
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {(totalValue > 0 || totalProductsValue > 0) && (
                        <div className="ms-total-card" style={{ marginTop: 16 }}>
                          <div className="ms-total-label">Total geral da comanda</div>
                          <div className="ms-total-value">
                            R$ {totalCommandValue.toFixed(2).replace(".", ",")}
                          </div>
                        </div>
                      )}

                      <div className="ms-footer-normal">
                        {isLoading ? (
                          <HallAppCenterContainer>
                            <div className="ms-loading-wrapper">
                              <AppLoading />
                              <div className="ms-loading-text">Processando...</div>
                            </div>
                          </HallAppCenterContainer>
                        ) : (
                          <div className="ms-footer-inner">
                            <AppButton
                              type="submit"
                              width="100%"
                              name="Salvar"
                              className="ms-btn-save"
                              disabled={isLoading}
                            />

                            <div className="ms-footer-secondary-actions">
                              {showGenerateCommandButton && (
                                <AppLinkButton
                                  type="button"
                                  width="100%"
                                  name="Gerar comanda"
                                  variant="danger"
                                  className="mb-0"
                                  onClick={() => handleGenerateCommand(values, resetForm)}
                                  disabled={isLoading}
                                />
                              )}

                              {showConfirmPaymentButton && (
                                <AppLinkButton
                                  type="button"
                                  width="100%"
                                  intent="success"
                                  name="Confirmar pagamento"
                                  variant="successOutline"
                                  className="mb-0"
                                  onClick={openPaymentModalByEvent}
                                  disabled={isLoading}
                                />
                              )}

                              {eventSelected && (
                                <AppButton
                                  type="button"
                                  width="100%"
                                  name="Cancelar agendamento"
                                  variant="danger"
                                  className="mb-0"
                                  onClick={canceledEvent}
                                  disabled={isLoading}
                                />
                              )}

                              <AppLinkButton
                                name="Fechar"
                                onClick={closeShow}
                                disabled={isLoading}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </Form>

                    {showCustomerDetails && hasSelectedCustomer && (
                      <CustomerDetailsModalV2
                        show={showCustomerDetails}
                        closeShow={() => setShowCustomerDetails(false)}
                        customer={{
                          id: values?.customerId || eventSelected?.customerId || null,
                          name: values?.name || "",
                          whatsapp: values?.whatsapp || "",
                          birthday: values?.birthday || null,
                          lastVisit: values?.lastVisit || null,
                        }}
                      />
                    )}
                  </>
                );
              }}
            </Formik>
          )}
        </Modal.Body>
      </Modal>

      {showForceModal && (
        <ConfirmModal
          textBtnConfirm="Sim, criar mesmo assim"
          show={showForceModal}
          title="Atenção"
          isLoading={isLoading}
          confirm={confirmForceCreate}
          closeModal={() => {
            setShowForceModal(false);
            setForcePayload(null);
            setPendingGenerateAfterForce(false);
          }}
        >
          <p>
            Existe uma <strong>folga ou feriado</strong> cadastrado para a{" "}
            <strong>data selecionada</strong>.
          </p>
          <p>
            Se continuar, o agendamento será criado mesmo assim e poderá{" "}
            <strong>desrespeitar o bloqueio</strong>.
          </p>
          <p>
            O bloqueio <strong>não será removido automaticamente</strong>. Se necessário, ajuste
            manualmente.
          </p>
          <p>
            <strong>Deseja criar o agendamento mesmo assim?</strong>
          </p>
        </ConfirmModal>
      )}

      {showModalCommand && (
        <ModalCommand
          show={showModalCommand}
          command={command}
          closeShow={() => {
            if (call) call();
            setShowModalCommand(false);
            closeShow();
          }}
        />
      )}

      {showModalPayment && (
        <CommandPaymentModal
          command={command}
          show={showModalPayment}
          closeShow={() => {
            if (call) call();
            setShowModalPayment(false);
            closeShow();
          }}
        />
      )}
    </div>
  );
}

export default ModalScheduling;